import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { AppBar, Box, Drawer } from '@mui/material';
import VerticalTabs from '../../Navigator/Tabs/VerticalTabs';
import { IPanelLinks } from 'src/models/IPanelLinks';

interface IProps {
  links: IPanelLinks[];
}

const MainLayout: FC<IProps> = ({ links }) => {
  return (
    <Box sx={{ borderRadius: 0 }}>
      <AppBar
        position='fixed'
        sx={{
          width: '60px'
        }}
      />
      <Drawer
        sx={{
          '& .MuiDrawer-paper': {
            transition: '0.5s all',
            width: '60px',
            boxSizing: 'border-box',
            borderRadius: 0
          }
        }}
        variant='permanent'
        anchor='left'
      >
        <div className='logo abbr'>SR</div>
        <VerticalTabs links={links} />
      </Drawer>
      <Box
        component='main'
        className={'active'}
        sx={{ margin: '0 0 0 auto', padding: '16px', minHeight: '100vh' }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout;
